/**
 * @generated SignedSource<<092a163eaa6f7290822051c2c5678d14>>
 * @relayHash 6df3b61373374b3cf5fce7cb1a4ae00e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ea3599f53b3067003f1d16b483219ce64610129a2ca5eb30a7413f45d983d66a

import type { ConcreteRequest } from 'relay-runtime';
export type ContextualCreateContentButtonQuery$variables = {
  spaceKey: string;
};
export type ContextualCreateContentButtonQuery$data = {
  readonly space: {
    readonly id: string | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
  } | null;
};
export type ContextualCreateContentButtonQuery = {
  response: ContextualCreateContentButtonQuery$data;
  variables: ContextualCreateContentButtonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "operation"
          },
          {
            "kind": "ScalarField",
            "name": "targetType"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ContextualCreateContentButtonQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContextualCreateContentButtonQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6df3b61373374b3cf5fce7cb1a4ae00e",
    "id": "ea3599f53b3067003f1d16b483219ce64610129a2ca5eb30a7413f45d983d66a",
    "metadata": {},
    "name": "ContextualCreateContentButtonQuery",
    "operationKind": "query",
    "text": "query ContextualCreateContentButtonQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
  }
};
})();

(node as any).hash = "b90cfbf7247643a29960682d0df2c943";

export default node;
